// extracted by mini-css-extract-plugin
export var gif = "_jp-0";